<div class="layout-col full">
  <elder-table
    class="flex"
    dense
    matSort
    [data]="data"
    [interactionMode]="'selection'"
    [selectionMultiEnabled]="false"
    (selectionSingleChange)="openWorkCenterOrder($event)"
  >
    <!-- id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="width: 25%" mat-sort-header="workOrderId">
        {{ 'context.id' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        <div class="layout-col">
          <span>
            {{ order.workOrderId }}
          </span>
          @if ((viewMode$ | async) === MexusViewMode.LIVE) {
            <small>
              {{ order.orderSchedule | isoInterval }}
            </small>
          }
        </div>
      </td>
    </ng-container>

    <!-- status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell mat-sort-header="state" *matHeaderCellDef>
        {{ 'context.status' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">{{ order.state }}</td>
    </ng-container>

    <!-- priority Column -->
    <ng-container matColumnDef="dispatchPriority">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="prioritySortOrder">
        {{ 'context.priority' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        {{ order.dispatchPriority }}
        <small>({{ 'orders.orderPriority.' + order.orderPriority | translate }})</small>
      </td>
    </ng-container>

    <!-- itemCount Column -->
    <ng-container matColumnDef="itemCount">
      <th mat-header-cell *matHeaderCellDef elderNumberCell mat-sort-header="total.itemCount">
        {{ 'context.items' | translate }}
      </th>
      <td mat-cell *matCellDef="let order" elderNumberCell>{{ order?.total?.itemCount }}</td>
    </ng-container>

    <!-- totalPieces Column -->
    <ng-container matColumnDef="totalPieces">
      <th mat-header-cell *matHeaderCellDef elderNumberCell mat-sort-header="total.piecesCount">
        {{ 'context.pieces' | translate }}
      </th>
      <td mat-cell *matCellDef="let order" elderNumberCell>{{ order?.total?.piecesCount }}</td>
    </ng-container>

    <!-- totalWeight Column -->
    <ng-container matColumnDef="totalWeight">
      <th
        mat-header-cell
        *matHeaderCellDef
        elderNumberCell
        mat-sort-header="total.totalWeight.value"
      >
        {{ 'context.weight' | translate }}
      </th>
      <td mat-cell *matCellDef="let order" elderNumberCell>
        {{ order?.total?.totalWeight | elderQuantity: false : Unit.kg : '1.0-0' }}
      </td>
    </ng-container>
  </elder-table>
</div>
